export default __webpack_public_path__ + "static/media/news-2.e16d7b54.jpg";